import { computed } from 'vue';

import { useCardTransactionRows } from '@peanuds/cards';
import { getIsoDateDaysAgo } from '@peanuds/shared';

import type { ControlSpendingTableRow } from '../internal/control-spendings-table.adapter';
import { CONTROL_SPENDINGS_RECENT_DAYS } from './useControlSpendingsTableFeed';

export const useControlSpendingsCardRows = () => {
  const cardTransactionRows = useCardTransactionRows();

  return computed<ControlSpendingTableRow[]>(() => {
    const recentFrom = getIsoDateDaysAgo(CONTROL_SPENDINGS_RECENT_DAYS);

    return cardTransactionRows.value.filter((row) => (row.dateAndTime ?? '') >= recentFrom);
  });
};
